export const getConversationsFiltersOpen = (state) =>
  state.conversations.filtersOpen;

export const getConversationsOrder = (state) =>
  state.conversations.filters.order;

export const getConversationsOnlyUnread = (state) =>
  state.conversations.filters.onlyUnread;

export const getConversationFiltersAreChanged = (state) =>
  state.conversations.filtersAreChanged;
